import { useTranslation } from "react-i18next";
import { MarketingContacts } from "@/partner/features/marketingContacts";
import { Meta } from "@/shared/components";

export function MarketingContactsPage() {
  const { t } = useTranslation();

  return (
    <>
      <Meta title={t("marketingContacts.pageTitle")} pageType="Partner" />
      <MarketingContacts />
    </>
  );
}
